import { useContext } from 'react'
import DataTable from '../components/DataTable'
import { KTSVG } from '../../_metronic/helpers'
import 'react-loading-skeleton/dist/skeleton.css'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import { postRequestOptions } from '../helpers/Fetchwrapper'
import GetPagePermission from '../components/GetPagePermission'
import { formatDecimalQuantity } from '../helpers/GlobalHelper'
import { AppContext } from '../context/AppContext'

function BlendingOrderList() {
	const { currentUser } = useContext(AppContext)
	const hasPermission = 1
	const canApprove = GetPagePermission('/approve-blending-orders')
	const canDelete = currentUser?.id === 3

	const postAction = async (url, confirmText, confirmButtonText) => {
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: confirmText,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText,
		})
		if (!confirm.isConfirmed) {
			return
		}

		try {
			const response = await fetch(url, postRequestOptions({}))
			const data = await response.json()
			if (data.success) {
				Swal.fire({
					icon: 'success',
					title: 'Success',
					text: data.successMessage,
				}).then(() => window.location.reload())
			} else {
				Swal.fire({
					icon: 'error',
					title: 'Error',
					text: data.errorMessage || data.errors || 'Action failed.',
				})
			}
		} catch (error) {
			Swal.fire({
				icon: 'error',
				title: 'Error',
				text: 'An error occurred.',
			})
		}
	}

	const columns = [
		{ value: 'id', title: 'Id', style: { textAlign: 'center' } },
		{ value: 'productionOrderNo', title: 'Production Order No', style: { textAlign: 'left' } },
		{ value: 'projectName', title: 'Project', style: { textAlign: 'left' } },
		{ value: 'productionDate', title: 'Production Date', style: { textAlign: 'left' } },
		{ value: 'productName', title: 'Product', style: { textAlign: 'left' } },
		{ value: 'productionQuantity', title: 'Plan Qty', style: { textAlign: 'right' }, hasHtmlComponent: true, htmlComponent: (row: any) => formatDecimalQuantity(row.productionQuantity) },
		// Empty until the actual quantity is saved at QC
		{ value: 'actualProductionQuantity', title: 'Actual Qty', style: { textAlign: 'right' }, hasHtmlComponent: true, htmlComponent: (row: any) => row.actualProductionQuantity === null || row.actualProductionQuantity === undefined ? '' : formatDecimalQuantity(row.actualProductionQuantity) },
		{ value: 'weightInKg', title: 'Weight KG', style: { textAlign: 'right' }, hasHtmlComponent: true, htmlComponent: (row: any) => formatDecimalQuantity(row.weightInKg) },
		{ value: 'batchNo', title: 'Batch No', style: { textAlign: 'left' } },
		{ value: 'status', title: 'Status', style: { textAlign: 'left' } },
		{ value: 'createdBy', title: 'Created By', style: { textAlign: 'left' } },
		{
			value: 'action',
			title: 'Action',
			style: { textAlign: 'left', whiteSpace: 'nowrap' },
			hasActionsComponent: true,
			actionsComponent: ((row: any) => {
				return (
					<>
						{row.status === 'Draft' &&
							<Link className="btn btn-light-primary btn-sm me-1" to={`/blending-order-edit/${row.id}`}>
								<KTSVG
									path="/media/svg/icons/Communication/Write.svg"
									className="svg-icon-5 svg-icon"
								/>		Edit
							</Link>
						}
						<Link className="btn btn-light-primary btn-sm me-1" to={`/blending-order-details/${row.id}`}>
							<KTSVG
								path="/media/svg/icons/Layout/Layout-grid.svg"
								className="svg-icon-5 svg-icon"
							/>		Details
						</Link>
						{row.status === 'Draft' && canApprove === 1 &&
							<button
								type="button"
								className="btn btn-light-success btn-sm me-1"
								onClick={() => postAction(
									`${process.env.REACT_APP_API_URL}blending-orders/approve/${row.id}`,
									'You want to approve this blending order?',
									'Yes, Approve'
								)}
							>
								Approve
							</button>
						}
						{row.status === 'Approved' &&
							<button
								type="button"
								className="btn btn-light-warning btn-sm me-1"
								onClick={() => postAction(
									`${process.env.REACT_APP_API_URL}blending-orders/start-wip/${row.id}`,
									'This will stock out required materials and move the order to WIP.',
									'Yes, Start WIP'
								)}
							>
								Start WIP
							</button>
						}
						{canDelete &&
							<button
								type="button"
								className="btn btn-light-danger btn-sm me-1"
								onClick={() => postAction(
									`${process.env.REACT_APP_API_URL}blending-orders/delete/${row.id}`,
									'This will permanently delete this blending order, its stock movements and accounting voucher. A blending order with packing orders cannot be deleted; delete its packing orders first.',
									'Yes, Delete'
								)}
							>
								Delete
							</button>
						}
					</>
				)
			}),
		},
	]

	const filters = {
		id: { filterType: 'like', filterValue: '' },
		productionOrderNo: { filterType: 'like', filterValue: '' },
		projectName: { filterType: 'like', filterValue: '' },
		productionDate: { filterType: 'like', filterValue: '' },
		productName: { filterType: 'like', filterValue: '' },
		productionQuantity: { filterType: 'like', filterValue: '' },
		actualProductionQuantity: { filterType: 'like', filterValue: '' },
		weightInKg: { filterType: 'like', filterValue: '' },
		batchNo: { filterType: 'like', filterValue: '' },
		status: { filterType: 'like', filterValue: '' },
		createdBy: { filterType: 'like', filterValue: '' },
	}

	const url = process.env.REACT_APP_API_URL + 'blending-orders/dt'

	return (
		<>
			{hasPermission === 1 &&
				<div className="card card-custom">
					<div className="card-header">
						<div className="card-title">
							<KTSVG path="/media/svg/icons/Text/Bullet-list.svg" className="svg-icon-1 svg-icon-primary" />
							<span className="text fw-bolder" style={{ marginLeft: '10px' }}>
								Blending Orders
							</span>
						</div>
						<div className="card-toolbar">
							<div className="d-flex justify-content-end">
								<Link to="/blending-order-create" className="btn btn-sm btn-primary"><i className="fa fa-plus"></i> Create Blending Order</Link>
							</div>
						</div>
					</div>

					<div className="card-body">
						<DataTable url={url} columns={columns} filters={filters} />
					</div>
				</div>
			}
		</>
	)
}

export default BlendingOrderList
